export default __webpack_public_path__ + "static/media/caret-bottom.03293f90.svg";